import React, { ComponentProps } from "react";
import { useLabels } from "../../../hooks/useLabels";

import { showDialogAsync } from "../../dialog-queue";

import { labels } from "./labels";
import { PriceDialog } from "./price-dialog";

function PriceDialogContainer({
	...dialogProps
}: Omit<ComponentProps<typeof PriceDialog>, "title" | "close" | "total">) {
	const [[title, close, total], areLabelsLoading] = useLabels([
		labels.title,
		labels.close,
		labels.total,
	]);

	if (areLabelsLoading) return null;

	return <PriceDialog close={close} title={title} total={total} {...dialogProps} />;
}

export function showPriceDialog() {
	return showDialogAsync(({ resolve }, { isOpen }) => (
		<PriceDialogContainer isOpen={isOpen} onClose={() => resolve()} />
	));
}
